import Vue from 'vue'
import store from '../vuex/store'
import Router from 'vue-router'
import AutopaySdkProductView from '../views/AutopaySdk/ProductView'
import AutopaySdkDoscMainView from '../views/AutopaySdk/Docs/DocsMainView'
import AutopaySdkDoscDeviceView from '../views/AutopaySdk/Docs/DocsDeviceView'
import AutopaySdkFilesView from '../views/AutopaySdk/Files/FilesView'
import AutopaySdkFilesDeviceView from '../views/AutopaySdk/Files/FilesDeviceView'
import AutopaySdkFaqView from '../views/AutopaySdk/Faq/FaqView'
import AutopaySdkFaqDeviceView from '../views/AutopaySdk/Faq/FaqDeviceView'
import AutopaySdkChangelogView from '../views/AutopaySdk/Changelog/ChangelogView'
import AutopaySdkChangelogDeviceView from '../views/AutopaySdk/Changelog/ChangelogDeviceView'
import { ROUTING } from '../const/routing.const'

const androidDeviceName = 'android'
const iosDeviceName = 'ios'

let lang = 'pl'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: ROUTING.main,
      redirect: ROUTING.autopaySdk.product
    },
    {
      path: ROUTING.autopaySdk.main,
      redirect: ROUTING.autopaySdk.product
    },
    {
      path: ROUTING.autopaySdk.product,
      name: 'AutopaySdkProductView',
      component: AutopaySdkProductView,
      meta: {
        pl: {
          title: 'Autopay SDK'
        },
        en: {
          title: 'Autopay SDK'
        }
      }
    },
    {
      path: ROUTING.autopaySdk.docs.main,
      name: 'AutopaySdkDoscMainView',
      component: AutopaySdkDoscMainView,
      meta: {
        pl: {
          title: 'Autopay SDK - dokumentacja'
        },
        en: {
          title: 'Autopay SDK - documentation'
        }
      },
      beforeEnter: (to, from, next) => {
        if (store.state.sdk.device && !store.state.sdk.isDocsSectionActive) {
          next({ path: ROUTING.autopaySdk.docs[store.state.sdk.device] })
          return
        }
        next()
      }
    },
    {
      path: ROUTING.autopaySdk.docs.android + '/:chapter?',
      name: 'AutopaySdkDoscDeviceViewAndroid',
      component: AutopaySdkDoscDeviceView,
      props: route => ({ chapter: route.params.chapter, selectedDevice: androidDeviceName }),
      meta: {
        pl: {
          title: 'Autopay SDK - dokumentacja android'
        },
        en: {
          title: 'Autopay SDK - documentation android'
        }
      }
    },
    {
      path: ROUTING.autopaySdk.docs.ios + '/:chapter?',
      name: 'AutopaySdkDoscDeviceViewiOS',
      component: AutopaySdkDoscDeviceView,
      props: route => ({ chapter: route.params.chapter, selectedDevice: iosDeviceName }),
      meta: {
        pl: {
          title: 'Autopay SDK - dokumentacja ios'
        },
        en: {
          title: 'Autopay SDK - documentation ios'
        }
      }
    },
    {
      path: ROUTING.autopaySdk.files.main,
      name: 'AutopaySdkFilesView',
      component: AutopaySdkFilesView,
      meta: {
        pl: {
          title: 'Autopay SDK - pliki do pobrania'
        },
        en: {
          title: 'Autopay SDK - download'
        }
      },
      beforeEnter: (to, from, next) => {
        if (store.state.sdk.device && !store.state.sdk.isDownloadSectionActive) {
          next({ path: ROUTING.autopaySdk.files[store.state.sdk.device] })
          return
        }
        next()
      }
    },
    {
      path: ROUTING.autopaySdk.files.android,
      name: 'AutopaySdkFilesAndroidView',
      component: AutopaySdkFilesDeviceView,
      props: {
        selectedDevice: androidDeviceName
      },
      meta: {
        pl: {
          title: 'Autopay SDK - pliki do pobrania android'
        },
        en: {
          title: 'Autopay SDK - download android'
        }
      }
    },
    {
      path: ROUTING.autopaySdk.files.ios,
      name: 'AutopaySdkFilesIosView',
      component: AutopaySdkFilesDeviceView,
      props: {
        selectedDevice: iosDeviceName
      },
      meta: {
        pl: {
          title: 'Autopay SDK - pliki do pobrania ios'
        },
        en: {
          title: 'Autopay SDK - download ios'
        }
      }
    },
    {
      path: ROUTING.autopaySdk.faq.main,
      name: 'AutopaySdkFaqView',
      component: AutopaySdkFaqView,
      meta: {
        pl: {
          title: 'Autopay SDK - FAQ'
        },
        en: {
          title: 'Autopay SDK - FAQ'
        }
      },
      beforeEnter: (to, from, next) => {
        if (store.state.sdk.device && !store.state.sdk.isFaqSectionActive) {
          next({ path: ROUTING.autopaySdk.faq[store.state.sdk.device] })
          return
        }
        next()
      }
    },
    {
      path: ROUTING.autopaySdk.faq.android,
      name: 'AutopaySdkFilesAndroidView',
      component: AutopaySdkFaqDeviceView,
      props: {
        selectedDevice: androidDeviceName
      },
      meta: {
        pl: {
          title: 'Autopay SDK - FAQ android'
        },
        en: {
          title: 'Autopay SDK - FAQ android'
        }
      }
    },
    {
      path: ROUTING.autopaySdk.faq.ios,
      name: 'AutopaySdkFilesIosView',
      component: AutopaySdkFaqDeviceView,
      props: {
        selectedDevice: iosDeviceName
      },
      meta: {
        pl: {
          title: 'Autopay SDK - FAQ iOS'
        },
        en: {
          title: 'Autopay SDK - FAQ iOS'
        }
      }
    },
    {
      path: ROUTING.autopaySdk.changelog.main,
      name: 'AutopayChangelogFaqView',
      component: AutopaySdkChangelogView,
      meta: {
        pl: {
          title: 'Autopay SDK - Changelog'
        },
        en: {
          title: 'Autopay SDK - Changelog'
        }
      },
      beforeEnter: (to, from, next) => {
        if (store.state.sdk.device && !store.state.sdk.isChangelogSectionActive) {
          next({ path: ROUTING.autopaySdk.changelog[store.state.sdk.device] })
          return
        }
        next()
      }
    },
    {
      path: ROUTING.autopaySdk.changelog.android,
      name: 'AutopayChangelogFilesAndroidView',
      component: AutopaySdkChangelogDeviceView,
      props: {
        selectedDevice: androidDeviceName
      },
      meta: {
        pl: {
          title: 'Autopay SDK - Changelog android'
        },
        en: {
          title: 'Autopay SDK - Changelog android'
        }
      }
    },
    {
      path: ROUTING.autopaySdk.changelog.ios,
      name: 'AutopayChangelogFilesIosView',
      component: AutopaySdkChangelogDeviceView,
      props: {
        selectedDevice: iosDeviceName
      },
      meta: {
        pl: {
          title: 'Autopay SDK - Changelog iOS'
        },
        en: {
          title: 'Autopay SDK - Changelog iOS'
        }
      }
    },
    {
      path: '*',
      redirect: ROUTING.main
    }
  ],
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  lang = Vue.config.lang || 'pl'
  document.title = to.meta[lang].title || ''
  if (window.isListnerSet) {
    next()
    return
  }
  window.isListnerSet = true
  window.addEventListener('langChange', function (e) {
    lang = e.detail
    document.title = to.meta[lang].title || ''
  })
  next()
})

export default router
